import { Locales, Column } from "@simplyk/common";
import { UseFormSetValue } from "react-hook-form";

import { useTranslateRows } from "../helpers/useTranslateRows";
import { TicketingTranslationsData } from "../translation.types";

import { RateFieldOutput } from "@/common/types/trpc";

interface SavedRateTranslation {
  title?: string | null;
  description?: string | null;
}

export function useTranslateRates({
  rates,
  translationLocale,
  setValue,
  existingTranslations,
}: {
  rates: Array<RateFieldOutput & { destinationIndex?: number }>;
  translationLocale: Locales;
  setValue: UseFormSetValue<TicketingTranslationsData>;
  existingTranslations?: ReadonlyArray<SavedRateTranslation | undefined>;
}) {
  const { isTranslating, translatedIds } = useTranslateRows<TicketingTranslationsData>({
    translationLocale,
    setValue: (path, value) => setValue(path as `translations.ratesFields.${number}.title`, value),
    rows: rates.map((rate, index) => {
      const destinationIndex = rate.destinationIndex ?? index;
      const saved = existingTranslations?.[destinationIndex];
      return {
        id: rate.id,
        fields: [
          {
            key: "title",
            path: `${Column.Translations}.ratesFields.${destinationIndex}.title`,
            source: rate.title ?? "",
            saved: saved?.title,
            isPlainText: true,
          },
          {
            key: "description",
            path: `${Column.Translations}.ratesFields.${destinationIndex}.description`,
            source: rate.description ?? "",
            saved: saved?.description,
          },
        ],
      };
    }),
  });

  return { isTranslating, translatedRateIds: translatedIds };
}
